import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const CalibrationScopeScreen = lazy(
  () => import('~/features/item-setup/pages/calibration-scope-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/calibration-scope')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <CalibrationScopeScreen />
    </Suspense>
  ),
});
